import type { PeptideStatus } from "@/lib/research/types";

const AVAILABILITY_MAP: Record<string, PeptideStatus> = {
	available: "available",
	"in-stock": "available",
	verfügbar: "available",
	soon: "soon",
	"coming-soon": "soon",
	"q3-2026": "soon",
	pipeline: "pipeline",
	restricted: "restricted",
};

/** Map Saleor peptide metadata availability string to PeptideStatus. */
export function mapAvailabilityToStatus(availability: string | null | undefined): PeptideStatus | null {
	if (!availability) return null;
	const key = availability.trim().toLowerCase();
	return AVAILABILITY_MAP[key] ?? null;
}

export function resolvePeptideStatus(
	availability: string | null | undefined,
	referenceStatus?: PeptideStatus | null,
): PeptideStatus | null {
	return mapAvailabilityToStatus(availability) ?? referenceStatus ?? null;
}
